module.exports = __webpack_public_path__ + "img/step3.028fb5d5.png";